// components/UsiRequiredModal.jsx
import { useState } from "react";
import { Info, X } from "lucide-react";

export default function UsiRequiredModal({ open, onLater, message }) {
  const [hideForWeek, setHideForWeek] = useState(false);

  if (!open) return null;

  const handleLater = () => {
    onLater(hideForWeek);
  };

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 p-4"
      role="dialog"
      aria-modal="true"
    >
      <div className="w-full max-w-md rounded-xl bg-white shadow-xl">
        {/* Header */}
        <div className="flex items-center justify-between border-b border-gray-200 px-6 py-4">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-blue-100">
              <Info className="h-5 w-5 text-blue-600" />
            </div>
            <h2 className="text-lg font-semibold text-gray-900">USI Required</h2>
          </div>
          <button
            onClick={handleLater}
            className="rounded-lg p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-colors"
            aria-label="Close"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* Content */}
        <div className="px-6 py-5">
          <p className="text-sm text-gray-600 leading-relaxed">
            {message || "You need to add your Unique Student Identifier (USI) to continue."}
          </p>
          
          <div className="mt-4 rounded-lg bg-blue-50 border border-blue-100 p-4">
            <p className="text-sm text-blue-900">
              <span className="font-medium">Why is this required?</span>
            </p>
            <p className="mt-1 text-xs text-blue-700">
              A USI is mandatory for all students enrolled in nationally recognised VET courses.
            </p>
          </div>
        </div>

        {/* Action */}
        <div className="border-t border-gray-200 px-6 py-4">
          <div className="mb-3 flex items-center gap-2">
            <input
              type="checkbox"
              id="hideForWeek"
              checked={hideForWeek}
              onChange={(e) => setHideForWeek(e.target.checked)}
              className="h-4 w-4 rounded border-gray-300 text-blue-600"
            />
            <label
              htmlFor="hideForWeek"
              className="text-sm text-gray-700 cursor-pointer select-none"
            >
              Don't remind me for 7 days
            </label>
          </div>
          <button
            onClick={handleLater}
            className="w-full rounded-lg bg-blue-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-blue-700 transition-colors"
          >
            Remind me later
          </button>
        </div>
      </div>
    </div>
  );
}